import getCollectionsByType from '@/services/repositories/collections/index'
import {
  conversionTypesRepository,
  inPageSkinGroupsRepository
} from '@/services/repository-factory'
import handleErrors from '@/services/handleErrors'
import InPageSkinGroup from '@/services/classes/InPageSkinGroup'

export const collectionTypes = {
  BROWSERS: 'browsers',
  CARRIERS: 'carriers',
  CATEGORIES: 'categories',
  CATEGORY_GROUPS: 'category-groups',
  COUNTRIES: 'countries',
  DEVICE_MODELS: 'device-models',
  DEVICE_VENDORS: 'device-vendors',
  IP_2_LOCATION_TYPES: 'ip2-location-types',
  LANGUAGE: 'language',
  CAMPAIGN_TRAFFIC_PLATFORMS: 'campaign-traffic-platforms',
  OPERATING_SYSTEMS: 'operating-systems',
  TRAFFIC_TYPES: 'traffic-types',
  INTERESTS: 'interests',
  MESSENGERS: 'messengers',
  REFERRER_TYPES: 'referrer-types'
}

const actions = {
  fetchCollectionsForCampaignForm() {
    this.fetchBrowsersCollection()
    this.fetchCarriersCollection()
    this.fetchCategoriesCollection()
    this.fetchCategoryGroupsCollection()
    this.fetchCountriesCollection()
    this.fetchDeviceModelsCollection()
    this.fetchIpToLocationsTypesCollection()
    this.fetchLanguageCollection()
    this.fetchOperatingSystemsCollection()
    this.fetchTrafficTypesCollection()
    this.fetchDeviceVendorsCollection()
    this.fetchInterestsCollection()
    this.fetchConversionTypes()
    this.fetchTrafficPlatformsCollection()
    this.fetchReferrerTypesCollection()
  },
  async fetchConversionTypes() {
    if (this.conversionTypes.length) return

    this.conversionTypesAreLoading = true
    try {
      const data = await conversionTypesRepository.list()
      this.conversionTypes = data
    } catch (error) {
      handleErrors(error)
    }
    this.conversionTypesAreLoading = false
  },
  async fetchMessengersList() {
    if (this.messengers.length) return

    this.messengersAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.MESSENGERS)
      this.messengers = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.messengersAreLoading = false
  },
  async fetchBrowsersCollection() {
    if (this.browsers.length) return

    this.browsersAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.BROWSERS)
      this.browsers = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.browsersAreLoading = false
  },
  async fetchCarriersCollection() {
    if (this.carriers.length) return

    this.carriersAreLoading = false
    try {
      const { data } = await getCollectionsByType(collectionTypes.CARRIERS)
      this.carriers = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.carriersAreLoading = false
  },
  async fetchCategoriesCollection() {
    if (this.categories.length) return

    this.categoriesAreLoading = false
    try {
      const { data } = await getCollectionsByType(collectionTypes.CATEGORIES)
      this.categories = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.categoriesAreLoading = false
  },
  async fetchCategoryGroupsCollection() {
    if (this.categoryGroups.length) return

    this.categoryGroupsAreLoading = false
    try {
      const { data } = await getCollectionsByType(collectionTypes.CATEGORY_GROUPS)
      this.categoryGroups = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.categoryGroupsAreLoading = false
  },
  async fetchCountriesCollection() {
    if (this.countries.length) return

    this.countriesAreLoading = false
    try {
      const { data } = await getCollectionsByType(collectionTypes.COUNTRIES)
      this.countries = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.countriesAreLoading = false
  },
  async fetchDeviceModelsCollection() {
    if (this.deviceModels.length) return

    this.deviceModelsAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.DEVICE_MODELS)
      this.deviceModels = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.deviceModelsAreLoading = false
  },
  async fetchIpToLocationsTypesCollection() {
    if (this.ip2LocationTypes.length) return

    this.ip2LocationTypesAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.IP_2_LOCATION_TYPES)
      this.ip2LocationTypes = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.ip2LocationTypesAreLoading = false
  },
  async fetchLanguageCollection() {
    if (this.languages.length) return

    this.languagesAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.LANGUAGE)
      this.languages = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.languagesAreLoading = false
  },
  async fetchTrafficPlatformsCollection() {
    if (this.trafficPlatforms.length) return

    this.trafficPlatformsAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.CAMPAIGN_TRAFFIC_PLATFORMS)
      this.trafficPlatforms = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.trafficPlatformsAreLoading = false
  },
  async fetchOperatingSystemsCollection() {
    if (this.operatingSystems.length) return

    this.operatingSystemsAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.OPERATING_SYSTEMS)
      this.operatingSystems = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.operatingSystemsAreLoading = false
  },
  async fetchTrafficTypesCollection() {
    if (this.trafficTypes.length) return

    this.trafficTypesAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.TRAFFIC_TYPES)
      this.trafficTypes = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.trafficTypesAreLoading = false
  },
  async fetchDeviceVendorsCollection() {
    if (this.deviceVendors.length) return

    this.deviceVendorsAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.DEVICE_VENDORS)
      this.deviceVendors = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.deviceVendorsAreLoading = false
  },
  async fetchInterestsCollection() {
    if (this.interests.length) return

    this.interestsAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.INTERESTS)
      this.interests = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.interestsAreLoading = false
  },
  async fetchInPageSkinGroups() {
    if (this.inPageSkinGroups.length) return

    this.inPageSkinGroupsAreLoading = true
    try {
      const data = await inPageSkinGroupsRepository.index()
      this.inPageSkinGroups = data.map((skinGroup) => new InPageSkinGroup(skinGroup))
    } catch (error) {
      handleErrors(error)
    }
    this.inPageSkinGroupsAreLoading = false
  },
  async fetchReferrerTypesCollection() {
    if (this.referrerTypes.length) return

    this.referrerTypesAreLoading = true
    try {
      const { data } = await getCollectionsByType(collectionTypes.REFERRER_TYPES)
      this.referrerTypes = data.data
    } catch (error) {
      handleErrors(error)
    }
    this.referrerTypesAreLoading = false
  }
}

export default actions
